import React from "react";
import { Box, Typography } from "../";

import {
  TaskStatusEnum,
  taskStatusToBackgroundColor,
  taskStatusToColor,
  taskStatusToPersian,
} from "digiwash-core";

interface LogisticTaskStatusType {
  status: TaskStatusEnum;
}

function LogisticTaskStatus(props: LogisticTaskStatusType) {
  return (
    <Box bg={taskStatusToBackgroundColor(props.status)} px="xm" py="m" br="l">
      <Typography color={taskStatusToColor(props.status)} fs="s">
        {taskStatusToPersian(props.status)}
      </Typography>
    </Box>
  );
}

export default LogisticTaskStatus;
